import { createFileRoute, notFound } from '@tanstack/react-router';
import { lazyScreen } from '@/shared/screen';

// Catálogo de blocos só existe em dev (09 §10.5): em produção a rota responde 404 e o chunk nem é pedido.
export const Route = createFileRoute('/dev/blocks')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-blocks-catalog'), 'BlocksCatalog') : () => null,
});
